function withAuth(WrapperComponent: any) {
  return (props: any) => {
    return <WrapperComponent {...props} />
  }
}

export default withAuth
